(function() {
    const backToTopButton = document.querySelector('.js-backToTop');
    if (!backToTopButton) return;

    const SCROLL_DOWN_THRESHOLD = 300;
    const SCROLL_UP_THRESHOLD = 100;
    const NEAR_TOP_THRESHOLD = 20;

    let lastScrollY = window.scrollY;
    let hasScrolledPastThreshold = false;
    let isScrollingToTop = false;

    function hasScrolledDownEnough(scrollTop) {
        return scrollTop > SCROLL_DOWN_THRESHOLD;
    }

    function hasScrolledUpEnough(scrollTop) {
        return (lastScrollY - scrollTop) > SCROLL_UP_THRESHOLD;
    }

    function isNearTop(scrollTop) {
        return scrollTop <= NEAR_TOP_THRESHOLD;
    }

    function hideBackToTopButton() {
        backToTopButton.classList.remove("is-visible");
    }

    function handleScroll() {
        if (isScrollingToTop) {
            return;
        }

        const scrollTop = window.scrollY;

        if (hasScrolledDownEnough(scrollTop)) {
            hasScrolledPastThreshold = true;
        }

        if (hasScrolledPastThreshold && hasScrolledUpEnough(scrollTop)) {
            backToTopButton.classList.add("is-visible");
            lastScrollY = scrollTop;
        } else if (isNearTop(scrollTop)) {
            hideBackToTopButton();
            hasScrolledPastThreshold = false;
            lastScrollY = scrollTop;
        } else if (scrollTop > lastScrollY) {
            lastScrollY = scrollTop;
        }
    }

    function scrollToTop() {
        isScrollingToTop = true;
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function checkScrollCompletion() {
        if (isScrollingToTop && window.scrollY === 0) {
            isScrollingToTop = false;
            hideBackToTopButton();
            hasScrolledPastThreshold = false;
            return;
        }

        handleScroll();
    }

    backToTopButton.addEventListener("click", scrollToTop);
    window.addEventListener("scroll", checkScrollCompletion);
}());
